import { UnprotectedAccessSecondsDuration } from './UnprotectedAccessSecondsDuration';
export function isValidProtectionSessionLength(number) {
    return typeof number === 'number' && Object.values(UnprotectedAccessSecondsDuration).includes(number);
}
